var $e8390eb96e247aac$exports = {};
$e8390eb96e247aac$exports = {
    "maximum": `\u{623}\u{642}\u{635}\u{649}`,
    "minimum": `\u{623}\u{62F}\u{646}\u{649}`
};


export {$e8390eb96e247aac$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
